export const duplicateParameterAutomations = (subSequence, start, end) => {
    console.log("DUPLICATE START=%s END=%s", start, end);
    getParametersWithAutomations(subSequence).forEach(
        param => {
            let automations = [... param.mixAutomation.automations];
            // first delete all automations between the start and end
            let automationsToDuplicate = automations.filter(
                a => a.step >= start && a.step < end);

            // now shift all automations after end to right by duration (end - start)
            for (let i in automations) {
                let automation = automations[i];
                if (automation.step > end) {
                    automations[i] = automation.getCopy();
                    automations[i].step += (end - start);
                }
            }

            for (let automation of automationsToDuplicate) {
                let duplicate = automation.getCopy(false);
                duplicate.step += (end - start);
                automations.push(duplicate);
            }

            automations.sort((a,b) => a.step - b.step);

            param.mixAutomation.automations = automations;
            param.mixAutomation.schedule();
            param.mixAutomation.clearCache();
            param.mixAutomation.updateRedux(true);
        });
}


export const deleteParameterAutomations = (subSequence, start, end) => {
    // first find all the parameter automations  (w mix enabled)
    // from this sub sequence
    getParametersWithAutomations(subSequence).forEach(
        param => {
            let automations = param.mixAutomation.automations;
            // first delete all automations between the start and end
            let automationsToKeep = automations.filter(
                a => a.step < start || a.step > end);

            // now shift all automations after end to left by duration (end - start)
            for (let i in automationsToKeep) {
                let automation = automationsToKeep[i];
                if (automation.step > end) {
                    automation.step -= (end - start);
                    automationsToKeep[i] = automation.getCopy();
                }
            }

            param.mixAutomation.automations = automationsToKeep;
            
            param.mixAutomation.schedule();
            param.mixAutomation.clearCache();
            param.mixAutomation.updateRedux(true);
        });
};

const getParametersWithAutomations = (subSequence) => {
    if (!subSequence.tracks) {
        return [];
    }
    let automatedParameters = [];
    subSequence.tracks.forEach(
        t => {
            automatedParameters = [
                ... automatedParameters,
                ... t.getAllParameters().filter(
                    p => p.mixAutomation.automations.length > 0)
            ];
        });

    return automatedParameters;
};

